import { Link } from 'react-router-dom';
import { categoriesMap, featuredComics } from '@/mocks/comics';

export default function EditorPicks() {
  const picks = featuredComics.slice(0, 3);

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6">
      <div className="mb-8 flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-background-50">
          <i className="ri-star-smile-line text-xl" aria-hidden="true"></i>
        </span>
        <div>
          <h2 className="font-heading text-2xl text-foreground-950">编辑精选</h2>
          <p className="mt-1 text-sm text-foreground-600">编辑部严选的深夜档重口味暗黑剧情，一读入坑</p>
        </div>
      </div>

      <div className="space-y-6">
        {picks.map((c, idx) => {
          const cat = categoriesMap[c.category];
          const flip = idx % 2 === 1;
          return (
            <article
              key={c.id}
              className={`grid grid-cols-1 items-center gap-6 overflow-hidden rounded-2xl border border-background-200/60 bg-background-100 md:grid-cols-2 ${flip ? 'md:[&>*:first-child]:order-2' : ''}`}
            >
              <Link
                to={`/comic/${c.id}`}
                data-product-shop
                className="relative block h-64 w-full overflow-hidden md:h-80"
              >
                <img
                  src={c.cover}
                  alt={`${c.title} ${c.tags.join('、')}精选封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded bg-accent-500 px-3 py-1 text-xs font-bold text-background-50">
                  编辑推荐
                </span>
              </Link>
              <div className="p-6 md:p-8">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded bg-secondary-200 px-2 py-0.5 text-xs text-secondary-950">{cat?.name}</span>
                  {c.tags.slice(0, 3).map((t) => (
                    <span key={t} className="rounded bg-secondary-100 px-2 py-0.5 text-xs text-foreground-500">
                      {t}
                    </span>
                  ))}
                </div>
                <h3 className="mt-4 font-heading text-2xl text-foreground-950">
                  <Link to={`/comic/${c.id}`} className="transition-colors hover:text-primary-400">
                    {c.title}
                  </Link>
                </h3>
                <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground-600">{c.description}</p>
                <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-foreground-500">
                  <span>作者 · {c.author}</span>
                  <span>{c.chapters} 话</span>
                  <span className="flex items-center gap-1 text-accent-400">
                    <i className="ri-fire-line" aria-hidden="true"></i> {c.rating} 分
                  </span>
                </div>
                <Link
                  to={`/comic/${c.id}`}
                  className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
                >
                  开始阅读 <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </Link>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}